module.exports = __webpack_public_path__ + "static/media/gnt.555cc81c.jpg";